
import { authorizeMe, axiosInstance } from './commonHeadApiLogic.js';

// Ensure authorization header is set before making authenticated requests
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe(); // Ensure the Authorization header is set
    return await apiFunction(...args);
  } catch (error) {
    // Handle errors as necessary
    console.error("Error in API request:", error);
    throw error;
  }
};


export const getHourlyBookingsAPI = (page, limit, type = "upcoming") => {
  return withAuthorization(() =>
    axiosInstance.get(`api/admins/hourly-bookings`, {
      params: { page, limit, type }
    })
  );
};

export const getEditingBookingsAPI = (page, limit, type = "upcoming") => {
  return withAuthorization(() =>
    axiosInstance.get(`api/admins/editing-bookings`, {
      params: { page, limit, type }
    })
  );
};

export const GetToFloatPhotographersgAPI = (page,limit,bookingId) => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/photographers/sorted`,
      {
        params: {
          page,
          limit,
          bookingId
        },
      }
    );
  });
};

export const GetToFloatVideographersAPI = (page,limit,bookingId) => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/photographers/videographers`,
      {
        params: {
          page,
          limit,
          bookingId
        },
      }
    );
  });
};

export const GetToFloatEditorAPI = (page,limit,bookingId) => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/photographers/editors/sorted`,
      {
        params: {
          page,
          limit,
          bookingId
        },
      }
    );
  });
};

export const GetToFloatLightingSetupAPI = (page,limit,bookingId) => {
  return withAuthorization(async () => {
    return axiosInstance.get(
      `/api/admins/photographers/lighting-setups`,
      {
        params: {
          page,
          limit,
          bookingId
        },
      }
    );
  });
};


export const updateCommissionAPI  = (data) => {
  return withAuthorization(() =>
    axiosInstance.put(`/api/admins/photographers/commissions`,data)
  );
};